import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RazorpayPlan {
  id: string;
  item: {
    amount: number;
    currency: string;
    name: string;
  };
  period: string;
  interval: number;
}

interface RazorpayPlansState {
  plans: RazorpayPlan[];
}

const initialState: RazorpayPlansState = {
  plans: [],
};

const razorpayPlansSlice = createSlice({
  name: 'razorpayPlans',
  initialState,
  reducers: {
    setRazorpayPlans: (state, action: PayloadAction<RazorpayPlan[]>) => {
      state.plans = action.payload;
    },
    addRazorpayPlan: (state, action: PayloadAction<RazorpayPlan>) => {
      state.plans.push(action.payload);
    },
    updateRazorpayPlan: (state, action: PayloadAction<{ id: string; plan: Partial<RazorpayPlan> }>) => {
      const index = state.plans.findIndex(plan => plan.id === action.payload.id);
      if (index !== -1) {
        state.plans[index] = { ...state.plans[index], ...action.payload.plan };
      }
    },
    removeRazorpayPlan: (state, action: PayloadAction<string>) => {
      state.plans = state.plans.filter(plan => plan.id !== action.payload);
    },
    clearRazorpayPlans: (state) => {
      state.plans = [];
    },
  },
});

export const {
  setRazorpayPlans,
  addRazorpayPlan,
  updateRazorpayPlan,
  removeRazorpayPlan,
  clearRazorpayPlans,
} = razorpayPlansSlice.actions;

export default razorpayPlansSlice.reducer;